import { initialAsyncState } from '~lib/shared/redux/types/state';
export const initialDoggosState = {
    listOfficeDoggos: { ...initialAsyncState },
};
export const DoggosActionTypes = {
    LIST_OFFICE_DOGGOS: '@@platform/doggos/LIST_OFFICE_DOGGOS',
};
